export const listGrades = [
  "2654435761",
  "1013904226",
  "3668339987",
  "2027808452",
  "387276917",
];
